import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";
const _preActionName = Pre.SMART_SPEAKER;

export function Play(
  areaId = 0,
  areaUId = null,
  deviceId = 0,
  deviceUId = null,
  playListId,
  playListUId,
  trackId,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    deviceId,
    deviceUId,
    playListId,
    playListUId,
    trackId,
  };

  return {
    type: _preActionName + Actions.PLAY,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function State(
  areaId = 0,
  areaUId = null,
  deviceId,
  deviceUId,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    deviceId,
    deviceUId,
  };
  return {
    type: _preActionName + Actions.STATE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function Resume(
  areaId = 0,
  areaUId = null,
  deviceId,
  deviceUId,
  playListId,
  playListUId,
  trackId,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    deviceId,
    deviceUId,
    playListId,
    playListUId,
    trackId,
  };

  return {
    type: _preActionName + Actions.RESUME,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function Pause(
  areaId = 0,
  areaUId = null,
  deviceId,
  deviceUId,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    deviceId,
    deviceUId,
  };

  return {
    type: _preActionName + Actions.PAUSE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function Stop(
  areaId = 0,
  areaUId = null,
  deviceId,
  deviceUId,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    deviceId,
    deviceUId,
  };
  return {
    type: _preActionName + Actions.STOP,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function Next(
  areaId = 0,
  areaUId = null,
  deviceId,
  deviceUId,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    deviceId,
    deviceUId,
  };

  return {
    type: _preActionName + Actions.NEXT,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function Previous(
  areaId = 0,
  areaUId = null,
  deviceId,
  deviceUId,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    deviceId,
    deviceUId,
  };
  return {
    type: _preActionName + Actions.PREVIOUS,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function Seek(
  areaId = 0,
  areaUId = null,
  deviceId,
  deviceUId,
  targetPosition,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    deviceId,
    deviceUId,
    targetPosition,
  };
  return {
    type: _preActionName + Actions.SEEK,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function ResetSeekLocally(deviceId, deviceUId) {
  var payload = {
    deviceId,
    deviceUId,
    targetPosition: 0,
  };

  // if (typeof deviceId === "number") payload.deviceId = deviceId;
  // else if (typeof deviceId === "string") payload.deviceUId = deviceId;

  return {
    type: _preActionName + Actions.SEEK,
    payload: { data: JSON.stringify(payload) },
    socket: { send: false, keepSocket: true },
  };
}

export function ChangeVolume(
  areaId = 0,
  areaUId = null,
  deviceId,
  deviceUId,
  volume,
  group = false,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    deviceId,
    deviceUId,
    volume,
    group,
  };
  return {
    type: _preActionName + Actions.CHANGE_VOLUME,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function ToggleMute(
  areaId = 0,
  areaUId = null,
  deviceId,
  deviceUId,
  mute,
  group,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    deviceId,
    deviceUId,
    mute,
    group,
  };
  return {
    type: _preActionName + Actions.TOGGLE_MUTE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function SetInput(
  areaId = 0,
  areaUId = null,
  deviceId,
  deviceUId,
  input,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    deviceId,
    deviceUId,
    input,
  };
  return {
    type: _preActionName + Actions.CHANGE_INPUT_SOURCE,
    accessToken: accessToken,
    payload,
    socket: { send: true, keepSocket: true },
  };
}

export function testSmartSpeaker(ip, storageServerId, accessToken) {
  return {
    type: _preActionName + Actions.TEST,
    accessToken,
    payload: {
      ip,
      storageServerId,
    },
    socket: { send: true, keepSocket: true },
  };
}

export function updateSlaveSmartSpeaker(
  masterDeviceUId,
  slaveDeviceUId,
  actionFunction = "ADD"
) {
  return {
    type: _preActionName + Actions.UPDATE_SLAVE,
    payload: { masterDeviceUId, slaveDeviceUId, actionFunction },
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}
